// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Od6Z","alert":"SettungsInbox_alert__1VOWP"};